import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import Icon from '../../elementals/icon'
import cls from './styles.scss'

const cx = classnames.bind(cls)

/**
 * We may need to make this controlled if the surrounding context ever needs to reference whether the property is saved
 * anywhere else. From my initial searches it seems fine for this to be represented like this. Perhaps we keep it
 * uncontrolled and a callback. I don't think it's wise to allow these components to mutate the object without some
 * structured update pattern being defined by the app, who ultimately owns the data.
 */
const PropertySaveIndicator = ({
  elmId,
  property = {},
  onSaveToggle,
  isCancelled = false,
}) => {
  const isSaved = property.is_currently_saved
  const iconBaseColor = isSaved ? 'error' : 'white'
  const iconHoverColor = isSaved ? 'error' : 'grayExtraLight'
  const iconStyle = isSaved ? 'solid' : 'regular'

  return (
    <Icon
      color={iconBaseColor}
      className={cx(
        'save-indicator',
        { 'is-saved': isSaved },
        { disabled: isCancelled }
      )}
      data-elm-id={`save_property_icon_${elmId}`}
      hoverColor={iconHoverColor}
      name='heart'
      iconStyle={iconStyle}
      onClick={() => onSaveToggle(property)}
      size='large'
    />
  )
}

PropertySaveIndicator.propTypes = {
  elmId: PropTypes.string.isRequired,
  property: PropTypes.shape({
    property_id: PropTypes.string.isRequired,
    is_currently_saved: PropTypes.bool,
  }).isRequired,
  onSaveToggle: PropTypes.func,
  isCancelled: PropTypes.bool,
}

/**
 * NOTE: I have purposely not exported this generally yet so as to force the scope this change for the ListingCard for now.
 * I would expect us to need to export this before repipe is complete.
 */
export default PropertySaveIndicator
